// Copyright (c) 2016 Deere & Company

import * as sharedClaimTypesActionCreator from '../../../../shared/action-creators/get-claim-types';
import actions from '../../../action-list';

export const readClaimTypes = () => sharedClaimTypesActionCreator.readClaimTypes(actions.UPDATE_CLAIM_MCC_FOLLOWUP_CLAIM_TYPES);



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/get-claim-types.js